import React from 'react';
import Banner from 'jsx/elements/banners/Banner';
import Button from 'jsx/elements/buttons/Button';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';
import img from 'images/lanshaefismat.svg';

export default function NoMonitoringBanner() {
  const { t } = useLocale();
  return (
    <Banner
      t={t}
      image={img}
      title={t('noMonitoringBanner_title')}
      main={t('noMonitoringBanner_body')}
      callToAction={
        <a href="mailto:creditinfo@creditinfo.is">
          <Button text={t('noMonitoringBanner_button')} />
        </a>
      }
    />
  );
}
